import { type CellContext } from '@tanstack/react-table';
import { useIntl } from 'react-intl';

import { ALLOWED_DAYS } from 'src/features/memberships/types';
import { Badge } from 'src/registry/ui/Badge';
import { cn } from 'src/utils';
import { generalMessagesDays } from 'src/utils/messages';

interface CellAllowedDaysProps<TData, TValue> extends CellContext<TData, TValue> {}

/*
 * This is a cell used to display all days of a week and colour only the enabled ones
 */
function CellAllowedDays<TData, TValue extends string[]>({ cell }: CellAllowedDaysProps<TData, TValue>) {
    const days: string[] = cell.getValue();
    const { formatMessage } = useIntl();

    return (
        <>
            {Object.keys(ALLOWED_DAYS).map((day) => (
                <Badge
                    variant="tag"
                    className={cn(
                        'mr-1 flex size-6 shrink-0 items-center justify-center bg-white px-0 uppercase opacity-30 last:mr-0',
                        days.includes(day) && 'font-semibold opacity-100',
                    )}
                    key={`${cell.id}-${day}`}
                >
                    {formatMessage(generalMessagesDays[day as keyof typeof generalMessagesDays]).charAt(0)}
                </Badge>
            ))}
        </>
    );
}

export { CellAllowedDays };
